import React, { useEffect } from 'react';
import { useHistory, Route, Switch, RouteProps, Redirect } from 'react-router-dom';
import './assets/styles/101.ui.scss';

import { DefaultLayout } from './layout';

import {
  MainPage,
  NewsPage,

  ProjectsPage,
  ProjectDetailPage,

  IntroductionPage,
  IntroductionDetailPage,
  ENDsPage,
  ENDDetailPage,
  PeoplePage,

  RecruitPage
} from './pages';


import MainMarkup from './pages/Main/MainContainer.markup';
import ProjectsMarkup from './pages/Projects/ProjectsContainer.markup';
import ProjectDetailMarkup from './pages/Projects/ProjectDetailContainer.markup';
import IntroductionMarkup from './pages/About/Introduction/IntroductionContainer.markup';
import PeopleMarkup from './pages/About/People/PeopleContainer.markup';
import ENDsMarkup from './pages/About/END/ENDsContainer.markup';
import EssayDetailMarkup from './pages/About/END/EssayDetailContainer.markup';
import DrawingDetailMarkup from './pages/About/END/DrawingDetailContainer.markup';

type DefaultRouteProps = {
  component: React.ComponentType<any>;
  layout: React.ComponentType;
} & RouteProps;


const DefaultRoute: React.FC<DefaultRouteProps> = ({ component: Component, layout: Layout, ...rest }) => (
  <Route
      {...rest}
      render={ props => (
        <Layout>
          <Component {...props} />
        </Layout>
      )}
  />
)



const App:React.FC = props => {
  const history = useHistory();
  const year:number = new Date().getFullYear();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [history.location.pathname]);
  

  return (
    <Switch>
      <DefaultRoute path="/markup/about/drawing" layout={DefaultLayout} component={DrawingDetailMarkup} />
      <DefaultRoute path="/markup/about/essay" layout={DefaultLayout} component={EssayDetailMarkup} />
      <DefaultRoute path="/markup/about/essay&drawing" layout={DefaultLayout} component={ENDsMarkup} />
      <DefaultRoute path="/markup/about/people" layout={DefaultLayout} component={PeopleMarkup} />
      <DefaultRoute path="/markup/about/introduction" layout={DefaultLayout} component={IntroductionMarkup} />
      <DefaultRoute path="/markup/projects/detail" layout={DefaultLayout} component={ProjectDetailMarkup} />
      <DefaultRoute path="/markup/projects/" layout={DefaultLayout} component={ProjectsMarkup} />
      <DefaultRoute path="/markup/" layout={DefaultLayout} component={MainMarkup} />
      
      

      <DefaultRoute path="/recruit" layout={DefaultLayout} component={RecruitPage} />

      
      <DefaultRoute exact path="/about/essay&drawing/:uid" layout={DefaultLayout} component={ENDDetailPage} />
      <DefaultRoute exact path="/about/essay&drawing" layout={DefaultLayout} component={ENDsPage} />

      <DefaultRoute exact path="/about/people" layout={DefaultLayout} component={PeoplePage} />

      <DefaultRoute exact path="/about/introduction/:uid" layout={DefaultLayout} component={IntroductionDetailPage} />
      <DefaultRoute exact path="/about/introduction" layout={DefaultLayout} component={IntroductionPage} />
      <Route path="/about">
        <Redirect to="/about/introduction" />
      </Route>

      <DefaultRoute exact path="/project/:uid" layout={DefaultLayout} component={ProjectDetailPage} />
      <DefaultRoute exact path="/projects/:type" layout={DefaultLayout} component={ProjectsPage} />
      <DefaultRoute path="/projects" layout={DefaultLayout} component={ProjectsPage}>
        <Redirect to="/projects/architecture" />
      </DefaultRoute>

      <DefaultRoute exact path="/news/:year" layout={DefaultLayout} component={NewsPage} />
      <DefaultRoute path="/news" layout={DefaultLayout} component={NewsPage}>
        <Redirect to={`/news/${year}`} />
      </DefaultRoute>
      {/* <Route path="/news">
        
      </Route> */}

      <DefaultRoute path="/" layout={DefaultLayout} component={MainPage} />
    </Switch>
  );
}


export default App;
